// extracted by mini-css-extract-plugin
export var blockHeader = "schedules-search-block-module--blockHeader--06415";
export var blockHeaderPicto = "schedules-search-block-module--blockHeaderPicto--3a212";
export var errorMessage = "schedules-search-block-module--errorMessage--9ef3d";
export var field = "schedules-search-block-module--field--1a221";
export var form = "schedules-search-block-module--form--9f29f";
export var formPart = "schedules-search-block-module--formPart--b7225";
export var searchButton = "schedules-search-block-module--searchButton--bf83d";